<template>
  <div :class="$style.container">
    <innate :innate="innate" :hidden="isInnateHidden" :is-mobile="true" />
  </div>
</template>

<script>
import Innate from '@/views/overlays/components/innate-details/innate.vue'

export default {
  name: 'innate-tooltip',
  components: { Innate },
  props: {
    hero: {
      type: String,
      required: true
    }
  },
  computed: {
    innate() {
      return this.getHeroAbilities(this.hero, 'innate')
    },
    abilities() {
      return this.getHeroAbilities(this.hero, 'abilities')
    },
    isInnateHidden() {
      const innateAbility = this.abilities.find((ability) => ability.name === this.innate)
      if (innateAbility) {
        return innateAbility.hidden
      }

      return true
    }
  }
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  width: 20.65rem;
  gap: 0.5rem;
}
</style>
